import React, { Component } from "react";
import { Form, Field } from "redux-form";

import userActivities from "../../constants/userActivities.js";

class CreateContactForm extends Component {
  componentDidUpdate(prevProps, prevState) {
    if (this.props.success && prevProps.success !== this.props.success) {
      if (window.scroll) {
        window.scroll({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo(0, 0);
      }
    }
  }

  render() {
    const { error, handleSubmit, submitting, success } = this.props;

    return (
      <Form onSubmit={handleSubmit} className="contact-form">
        {error && <div className="form__error">{error}</div>}
        {success && <div className="form__success">{this.props.t("messageSent")}</div>}

        <div>
          <Field
            className="form__field"
            name="firstname"
            component="input"
            type="text"
            placeholder={this.props.t("firstname")}
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="lastname"
            component="input"
            type="text"
            placeholder={this.props.t("name")}
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="organization"
            component="input"
            type="text"
            placeholder={this.props.t("company")}
            required
          />
        </div>

        {/* activity */}
        <Field
          className="form__field"
          name="activity"
          component="select"
          placeholder={this.props.t("activity")}
          required
          type="text"
        >
          {userActivities.map((activity, id) => {
            return (
              <option key={id} value={activity.id}>
                  {this.props.t("userActivities:activity" + activity.id + "title")}
              </option>
            );
          })}
        </Field>

        {/* address */}
        <div>
          <Field
            className="form__field"
            name="address"
            component="input"
            placeholder={this.props.t("address")}
            type="text"
            required
          />
        </div>

        <div className="contact__form-zip">
          <Field
            className="form__field"
            name="postalCode"
            component="input"
            placeholder={this.props.t("postCode")}
            type="text"
            required
          />
        </div>

        <div className="contact__form-city">
          <Field
            className="form__field"
            name="city"
            component="input"
            placeholder={this.props.t("city")}
            type="text"
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="country"
            component="input"
            placeholder={this.props.t("country")}
            type="text"
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="phone"
            component="input"
            placeholder={this.props.t("phoneNumber")}
            type="text"
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="organizationRole"
            component="input"
            placeholder={this.props.t("job")}
            type="text"
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="email"
            component="input"
            placeholder={this.props.t("emailAdress")}
            type="text"
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="subject"
            component="input"
            placeholder={this.props.t("subjectMessage")}
            type="text"
            required
          />
        </div>

        <div>
          <Field
            className="form__field"
            name="message"
            component="textarea"
            placeholder={this.props.t("yourMessage")}
            type="textarea"
            cols="24"
            rows="6"
            style={{ resize: "none" }}
            required
          />
        </div>

        <div>
          <button className="button" type="submit">
            {submitting ? this.props.t("messageSending") : this.props.t("sendButton")}
            &nbsp;<i className="i-arrow-right f7" />
          </button>

          <div className="contact__form-mandatory">
            {this.props.t("account:requiredSign")}
          </div>
        </div>
      </Form>
    )
  }
}

export default CreateContactForm;



// WEBPACK FOOTER //
// ./src/components/forms/CreateContactForm.js